import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/**
 * Text input dengan dropdown preset di kanan.
 * User bisa: (a) ketik bebas, atau (b) pilih preset dari dropdown → langsung terisi.
 *
 * Props:
 *  - value, onChange(v)
 *  - presets: string[]  (mis. ["Termin 1", "Termin 2", ...])
 *  - placeholder, testid, className
 */
export default function NotePresetInput({
  value,
  onChange,
  presets = ["Termin 1", "Termin 2", "Termin 3", "Termin 4", "Termin Akhir", "Retensi", "DP / Uang Muka"],
  placeholder = "Ketik atau pilih preset…",
  testid,
  className = "",
  disabled = false,
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`relative w-full ${className}`}>
      <Input
        data-testid={testid}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className="rounded-none text-[11px] pr-8"
      />
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button
            type="button"
            data-testid={testid ? `${testid}-preset-btn` : undefined}
            disabled={disabled}
            aria-label="Pilih preset note"
            onClick={(e) => { e.preventDefault(); setOpen((v) => !v); }}
            className="absolute right-0 top-1/2 -translate-y-1/2 h-7 w-7 flex items-center justify-center text-slate-500 hover:text-[#0B1D3A] hover:bg-slate-100 disabled:opacity-50"
          >
            <ChevronDown size={14} />
          </button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-48 p-0 rounded-none bg-white z-50">
          <div className="border-b border-slate-100 px-2 py-1 overline text-[9px] text-slate-500 font-semibold">Preset Note</div>
          <div className="max-h-64 overflow-y-auto">
            {presets.map((p) => (
              <button
                key={p}
                type="button"
                data-testid={testid ? `${testid}-preset-${p.toLowerCase().replace(/\s+/g, "-")}` : undefined}
                onClick={() => { onChange(p); setOpen(false); }}
                className="w-full text-left px-3 py-1.5 text-xs hover:bg-slate-100 transition-colors"
              >
                {p}
              </button>
            ))}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
